import * as React from 'react';
import { UIState } from 'data/UIState';
import { observer } from 'mobx-react';
import {PageEnum} from "components/nav/PageEnums";
import './PageWrapper.pcss';

export interface IPageWrapperProps {
	onContentScroll?:(scrollTop:any)=>void;
	pageEnum:PageEnum;
	alerts?:any;
	header?:any;
	static?:boolean;
	contentStyle?:any;
	noPadding?:boolean;
};

@observer
export class PageWrapper extends React.Component<IPageWrapperProps> {

	componentDidMount() {
    setTimeout(UIState.hideNav, 500);
  }

	handleShowNavClick = () => {
		UIState.showNav();
	}

	paneDidMount = (node) => {
		console.log("PageWrapper paneDidMount")
		const onContentScroll = this.props.onContentScroll;
    if (node && undefined!=onContentScroll) {
      node.addEventListener('scroll', (e) => {
				console.log("PageWrapper paneDidMount")
				onContentScroll(e.target.scrollTop);
			});
    }
	}

	render() {

		// this.props.contentStyle
		const contentStyle = {
			marginTop:this.props.header ? '168px' : '54px',
			width:'100%',
			...this.props.contentStyle
		}

		// this.headerStyle
		const headerStyle = {
			right:'0px'
		}

		return (
			<main id={"maincontent"}>
				<div className={`${this.props.pageEnum.name} center-column no-right${UIState.iOS?' ios':''}`}>
					<div className="header" tabIndex={0} style={headerStyle}>
						<div className="openNav" onClick={this.handleShowNavClick} >
							{UIState.windowWidth<=900 && <i className="material-icons">menu</i>}
							<h1>{UIState.currentPageTitle}</h1>
						</div>
						{this.props.header &&
						<div style={{marginTop:'54px'}}>
							{this.props.header}
						</div>
						}
					</div>
					<div ref={this.paneDidMount} className={`content${this.props.static ? ' static':''}`} style={contentStyle}>
						{this.props.alerts}
						<div className={`content-body${this.props.noPadding ? ' no-padding' : ''}`}>
							<div>{this.props.children}</div>
						</div>
					</div>
				</div>
			</main>
		)
	}
}
